<mat-button-toggle-group class="without-checked-state">
  <mat-button-toggle
    h3TrackAs
    [eventId]="'show_help_popup'"
    [subBucket]="'frame'"
    (click)="help()"
  >
    <fa-icon [icon]="faQuestion" [fixedWidth]="true"></fa-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
